import React, {useRef, useCallback} from 'react';

import {observer} from 'mobx-react';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';

import {useStores} from '../../../Hooks';
import AvatarRow from '../../Shared/AvatarRow';
import {openOwnerPickerModal} from './projectOwnersHelpers';

const labelClass = 'text-[11px] font-semibold text-main-normal tracking-[0.5px]';

const OwnersSection = observer(({owners, onChange}) => {
    const {generalStore, modalStore} = useStores();
    const addRef = useRef(null);

    const handleOpenPicker = useCallback(() => {
        openOwnerPickerModal({
            workspace: generalStore.workspace,
            currentOwnerIds: owners.map((o) => String(o._id || o)),
            modalStore,
            addRef,
            onSave: (selectedMembers) => onChange(selectedMembers),
        });
    }, [generalStore.workspace, modalStore, owners, onChange]);

    return (
        <div>
            <label className={`block mb-1 ${labelClass}`}>OWNERS</label>
            <div data-testid="owners-section" className="flex items-center gap-2 px-3 py-2 rounded-lg border border-panels-normal">
                <AvatarRow items={owners} />
                <div
                    ref={addRef}
                    data-testid="owners-add-button"
                    className="flex items-center justify-center w-6 h-6 rounded-full border border-panels-normal cursor-pointer hover:bg-panels-normal"
                    onClick={handleOpenPicker}
                >
                    <PersonAddAltOutlinedIcon className="text-main-hover" style={{fontSize: 14}} />
                </div>
            </div>
        </div>
    );
});

export default OwnersSection;
